<button *ngIf="transaction.attributes.state === stateEnum.WAITING_PAYMENT && !transaction.attributes.marked_as_sent"
    (click)="goToDetail($event)" style="min-width: fit-content !important;" mat-button>
    Pagar
    <mat-icon>chevron_right</mat-icon>
</button>

<button *ngIf="transaction.attributes.state !== stateEnum.WAITING_PAYMENT || transaction.attributes.marked_as_sent" mat-stroked-button
    (click)="goToDetail($event)" style="min-width: fit-content !important;">
    <mat-icon>chevron_right</mat-icon>
</button>
